import {isEqual} from 'lodash';
import {IUserInfo} from '../../../store/auth/atoms';
import {TypeAccountRoles} from '../../../shared/types/user-account.types';

export const getIsUserWorker = (user?: IUserInfo | null) => {
  if (!user) {
    return false;
  }

  const arr1 = [...(user?.roles ?? [])].sort();
  const arr2 = [TypeAccountRoles.WORKER, TypeAccountRoles.VIEWER].sort();
  return isEqual(arr1, arr2);
};
